// extracted by mini-css-extract-plugin
module.exports =  {"tdx-error-page":"ErrorPage-module__tdx-error-page___bFRUt"};